import React from "react";
import { Terminal } from "lucide-react";

export default function ChatHeader() {
  return (
    <div className="flex items-center justify-between px-5 h-12 border-b border-white/10 bg-[#0A0A0C]">
      <div className="flex items-center gap-2.5">
        <Terminal size={14} className="text-[#FF5722]" />
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-400">
          print-hub@bengaluru ~ %
        </span>
      </div>
      <div className="flex items-center gap-2 text-[10px] font-mono text-zinc-500">
        <span className="w-1.5 h-1.5 bg-[#10B981] rounded-full pulse-dot" />
        gemini-2.5-flash
      </div>
    </div>
  );
}
